export default __webpack_public_path__ + "static/media/presentation-3.a7edff21.png";